<template>
  <thead>
    <tr>
      <th style="width:30%;background-color:white; border-bottom:none; border-top:none;"/>

      <th colspan="3" class="step1 titre withborder">{{ $t('evaluations.head.step.step1') }}</th>
      <th colspan="9" class="step21 titre withborder">{{ $t('evaluations.head.step.step2') }}</th>
      <th colspan="4" class="step3 titre withborder">{{ $t('evaluations.head.step.step3') }}</th>
      <th class="score titre">{{ $t('evaluations.head.step.score') }}</th>
    </tr>

    <tr>
      <th style="border-bottom:none; border-top:none;background-color:white;"/>

      <th colspan="3" class="step1 withborder">{{ $t('evaluations.head.category.life_habit') }}</th>
      <th colspan="6" class="step21 withborder">{{ $t('evaluations.head.category.help_used') }}</th>
      <th colspan="3" class="step23 withborder">{{ $t('evaluations.head.category.difficulty_level') }}</th>
      <th colspan="4" class="step3 withborder">{{ $t('evaluations.head.category.satisfaction_level') }}</th>
      <th class="score"/>
    </tr>
    <tr>
      <th style="border-bottom:none; border-top:none;background-color:white;"/>
      <th colspan="3" class="step1 withborder"/>
      <th colspan="2" class="step21 withborder" style="text-align:center"><a style="color: dodgerblue" @click="showHelpModal()"><fa icon="question-circle" size="lg"/></a></th>
      <th colspan="4" class="step22 withborder" style="text-align:center">{{ $t('evaluations.head.step.human_help') }} <a style="color: dodgerblue" @click="showHumanModal()"><fa icon="question-circle" size="lg"/></a></th>
      <th colspan="3" class="step23 withborder"/>
      <th colspan="4" class="step3 withborder"/>
      <th class="score"/>
    </tr>

    <tr class="label-vertical">
      <th style=" border-top:none;background-color:white;"/>

      <th class="step1"><span>{{ $t('evaluations.head.criteria.performed') }}</span></th>
      <th class="step1 lights1"><span>{{ $t('evaluations.head.criteria.not_performed') }}</span></th>
      <th class="step1 withborder"><span>{{ $t('evaluations.head.criteria.na') }}</span></th>

      <th class="step21"><span>{{ $t('evaluations.head.criteria.tech_help') }}</span></th>
      <th class="step21 lights2 withborder"><span>{{ $t('evaluations.head.criteria.amenagement') }}</span></th>
      <th class="step22"><span>{{ $t('evaluations.head.criteria.no_help') }}</span></th>
      <th class="step22 lights2"><span>{{ $t('evaluations.head.criteria.light') }}</span></th>
      <th class="step22"><span>{{ $t('evaluations.head.criteria.heavy') }}</span></th>
      <th class="step22 lights2 withborder"><span>{{ $t('evaluations.head.criteria.full') }}</span></th>

      <th class="step23"><span>{{ $t('evaluations.head.criteria.low') }}</span></th>
      <th class="step23 lights2"><span>{{ $t('evaluations.head.criteria.medium') }}</span></th>
      <th class="step23 withborder"><span>{{ $t('evaluations.head.criteria.lot') }}</span></th>

      <th class="step3"><span>{{ $t('evaluations.head.criteria.very_satisfied') }}</span></th>
      <th class="step3 lights3"><span>{{ $t('evaluations.head.criteria.satisfied') }}</span></th>
      <th class="step3"><span>{{ $t('evaluations.head.criteria.unsatisfied') }}</span></th>
      <th class="step3 lights3 withborder"><span>{{ $t('evaluations.head.criteria.very_unsatisfied') }}</span></th>
      <th class="score"/>
    </tr>

    <b-modal ref="helpModal" :title="$t('evaluations.head.button.tooltip.help_title')" ok-only ok-variant="info" @ok.prevent="closeHelpModal()">
      <p style="font-size: 1.5em">{{ $t('evaluations.head.button.tooltip.help') }}</p>
    </b-modal>
    <b-modal ref="humanModal" :title="$t('evaluations.head.button.tooltip.human_title')" ok-only ok-variant="info" @ok.prevent="closeHumanModal()">
      <p style="font-size: 1.5em">{{ $t('evaluations.head.button.tooltip.human') }}</p>
    </b-modal>
  </thead>
</template>

<script>
export default {
  name: 'EvaluationHead',
  methods: {
    showHelpModal () {
      this.$refs.helpModal.show()
    },
    showHumanModal () {
      this.$refs.humanModal.show()
    },
    closeHelpModal () {
      this.$refs.helpModal.hide()
    },
    closeHumanModal () {
      this.$refs.humanModal.hide()
    }
  }
}

</script>

<style scoped lang="scss">

.label-vertical span{
    -ms-transform: rotate(-180deg); /* IE 9 */
    -webkit-transform: rotate(-180deg); /* Chrome, Safari, Opera */
    transform: rotate(-180deg);
}
.titre {
    font-size:20px;
}
.table thead th {
    vertical-align: top;
    border-bottom: 2px solid #ffffff;
}
    th span {
        vertical-align: middle;
        height:150px;
    }

    .withborder{

         border-right-style:solid;
         border-right-color:white;
     }

thead  tr:first-child th{
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 10;
}

thead  tr:nth-child(2) th{
  position: sticky;
  position: -webkit-sticky;
  top: 56px;
  z-index: 10;
}

thead  tr:nth-child(3) th{
  position: sticky;
  position: -webkit-sticky;
  top: 101px;
  z-index: 10;
}

thead  tr:nth-child(4) th{
  position: sticky;
  position: -webkit-sticky;
  top: 146px;
  z-index: 10;
}

.step1 {
  background-color: #bbced2;
}

.step21 {
  background-color: #9bdec0;
}

.step22 {
  background-color: #9bdec0;
}

.step23 {
  background-color: #9bdec0;
}

.step3 {
  background-color: #bbced2;
}

.score {
  background-color: #ffffcc;
}

.lights1 {
  background-color: #d3e9ed;
}

.lights2 {
  background-color: #cae6da;
}

.lights3 {
  background-color: #d3e9ed;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/evaluation/EvaluationHead.vue